<template>

        <div class="uk-card uk-card-default uk-card-body">
        <div v-if="form_title"><h2>{{form_title}}</h2></div>
        <div v-if="!submitted || formError" class="form-questions-wrapper card-body">
            <div class="row">
            <div v-for="(field, i) in fieldList" :class="{'col-md-6': !checkForMulti(field[1]), 'col': checkForMulti(field[1])}">
                        <FloatFieldInput @keyup.enter.native="enterSubmit(generate_input_data(field))" :data="generate_input_data(field)" @inputevent="function(input){formOutput[field[0]]=input;  errors[field[0]]=false; checkForCompletion(input, field[0]);}" @fieldError="function(error){errors[field[0]]=error}"/>
                        <MultiSelectObject v-if="checkForMulti(field[1])" :options="MultiList(field[1])" @chosen="function(input){formOutput[field[0]]=input; errors[field[0]]=false; checkForCompletion()}" :button="field[0]"></MultiSelectObject>
            </div>
            </div>
            <div v-if="footer_html" v-html="footer_html"></div>
            <button @click="checkAndSubmit" :class="{'uk-button':true, 'uk-button-danger':!this.finished, 'uk-button-primary':this.finished}">Submit</button>
    <div class="checklist">
        <div v-html="prop_errors"></div>
        <div v-for="(field, i) in fieldList">
        <div v-show="typeof(errors[field[0]]) == 'string'" class="checkListBad">
            <span class="uk-margin-small-right" uk-icon="icon: close"></span>{{ convertCamelCase(field[0]) }} {{ errors[field[0]] }}
        </div>
        <div v-show="typeof(errors[field[0]]) == 'boolean'" class="checkListGood">
            <span class="uk-margin-small-right" uk-icon="icon: check"></span>{{ convertCamelCase(field[0]) }}
        </div>
        </div>

    </div>
        </div>
        <div v-if="submitted && !formError" class="form-questions-wrapper card-body">
            <div class="row">
                <h1>{{ success_message }}</h1>
            </div>
        </div>
    </div>


</template>

<script>

    import FloatFieldInput from "./Input.vue"
    import validators from '../../utils/validate.js';
    import MultiSelectObject from "./MultiSelect/MultiSelectObject.vue"
    import apiCall from '../../store/apicall.js'

    export default {
        name: "formContainer",
        components: {
            FloatFieldInput,
            MultiSelectObject
        },
        props: ["fieldList", "resetSignal", "formError", "success_message", "form_title", "footer_html", "prop_errors"],
        data: function () {
				return {
                fieldListex: [
                        ['username'],
                        ['password'],
                        ['first_name'],
                        ['last_name'],
                        ['employee_id'],
                        ['state'],
                        ['zip'],
                        ['street'],
                        ['skills', {'select': [{display: 'Swimming', value: 's'}, {display: 'Basket Weaving', value: 'b'}]}],
                        ['abilities', {'multi-select': [{label: 'Swimming', value: 14}, {label: 'Basket-Weaving', value: 22}]}]
        ],
                    validators: validators,
                    fieldData: {},
                    formOutput: {},
                    errors: {},
                    variant: 'danger',
                    available_objects: [],
                    checkedFields: [],
                    inputValues: [],
                    phone:"",
                    email:"",
                    finished: false,
                    submitted: false,
                    checkList: false,
				}
			},
        mounted() {
            // console.log("FIELDLIST", this.fieldList)
            for (var i = 0; i < this.fieldList.length; i++) {

                this.$set(this.errors, this.fieldList[i][0], "");
                if (typeof(this.fieldList[i][1]) == 'object') {
                    if ('multi-select' in this.fieldList[i][1]) {
                        this.$set(this.errors, this.fieldList[i][0], false)
                        this.formOutput[this.fieldList[i][0]] = []
                    }
                }

            }
        },
        watch: {
            resetSignal: function (val) {
                if (val) {

                    this.fieldData = {};
                    this.formOutput = {};
                    // this.errors = {};
                    this.variant = 'danger';
                    // this.available_objects= [];
                    this.finished = false;
                    this.submitted = false;
                    // this.resetSignal = false;
                    for (var i = 0; i < this.fieldList.length; i++) {
                        this.$set(this.errors, this.fieldList[i][0], false)
                    }

                }
            },
        },
        computed: {
            form_component_names: function() {
                let holder = [];

                for (var i = 0; i < this.fieldList.length; i++) {
                    // console.log("pushed")
                    holder.push(this.fieldList[i][0])
                }
                return holder
            }
        },

        methods: {
            enterSubmit: function(field_data){
                if (field_data.type != 'textarea'){
                    this.checkAndSubmit()
                }

            },
            checkForCompletion: function(input, field) {
                this.$emit('input', [field, this.formOutput])
                // console.log(field)
                // some standard checks
                if (this.formOutput['confirmPassword']) {
                    if (this.formOutput['confirmPassword'] != this.formOutput['password']){
                        this.errors.confirmPassword = "Passwords dont match!"
                    } else {
                        this.errors.confirmPassword = false
                    }
                }
                if (this.formOutput['createUsername']) {
                    if (this.formOutput['createUsername'].length < 4){
                        this.errors.createUsername = "This username is too short"
                    }
                    let _t = this;
                    apiCall.post('/accounts/create-user/', {'username': this.formOutput['createUsername'], 'username_check': 1}).then(
                        function(response){
                            console.log(response)
                            if (response.data == "1"){
                                console.log("username is new!")
                            } else {
                                _t.errors.createUsername = "This username has already been taken!"
                            }
                        }
                    )
                }

                if (this.formOutput['last_name'] && this.formOutput['employee_id']){
                    let _t = this;
                    apiCall.post('/accounts/create-user/', {'last_name': this.formOutput['last_name'], 'id': this.formOutput['employee_id'], 'employee_id_check': 1}).then(
                        function(response){
                            if (response.data == 1){
                                console.log("employee id is valid!")
                            }
                            else{
                                _t.errors.employee_id = response.data
                            }
                        }
                    )
                }
                // console.log("ERRORS", this.errors)
                this.finished = false;
                this.variant = 'warning';
                var finished = false;
                for (var i = 0; i < this.form_component_names.length; i++) {
                    var key = this.form_component_names[i];
                    if (!this.formOutput[key]){
                        return false;
                    }
                }
                for (var key in this.errors){
                    if (this.errors[key]){
                        return false
                    }
                }
                this.variant = 'success';
                this.finished = true;
                return true
            },

            convertCamelCase: function(word) {
                var result = word.replace( /([A-Z])/g, " $1" );
                var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                return finalResult
            },
            checkForMulti: function(object) {
                if (typeof object == 'object'){
                    if (Object.keys(object)[0] == 'multi-select'){
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            checkAndSubmit: function() {
              if (this.finished){
                  for (var i = 0; i < this.form_component_names.length; i++) {
                      var key = this.form_component_names[i];
                      if (this.formOutput[key] instanceof Array) {
                          console.log("IS ARRAY")
                          for (var j = 0; j < this.formOutput[key].length; j++) {
                              this.formOutput[key][j] = this.formOutput[key][j].value
                          }
                      }
                  }

                  this.$emit('output', this.formOutput)

                  this.submitted = true;
              }  else {
                  console.log('Still not Done')
              }
            },
            MultiList: function(object){
              var k = Object.keys(object)[0];
              return object[k]
            },
            generate_input_data: function(field_type_input) {
                var field_type = field_type_input[0]

                    if (field_type == 'first_name') {
                        // this.available_objects.push(field_type);
                        this.fieldData['first_name'] = {
                            select: false,
                            type: "name",
                            id: "first-name",
                            label: "First Name",
                            placeholder: "John",
                            error: false,
                            errorMessage:
                                "Please enter a valid name",
                            constraints: validators.name,
                        };
                        return this.fieldData['first_name'];
                    } else if (field_type == 'last_name') {
                        // this.available_objects.push(field_type);
                        this.fieldData['last_name'] = {
                            select: false,
                            type: "name",
                            id: "last-name",
                            label: "Last Name",
                            placeholder: "Smith",
                            error: false,
                            errorMessage:
                                "Please enter a valid name",
                            constraints: validators.name,
                        };
                        return this.fieldData['last_name'];

                    } else if (field_type == 'employee_id') {
                        // this.available_objects.push(field_type);
                        this.fieldData['employee_id'] = {
                            select: false,
                            type: "name",
                            id: "employee-id",
                            label: "Employee ID",
                            placeholder: "1234567",
                            error: false,
                            errorMessage:
                                "Please enter a valid id",
                            constraints: validators.name,
                        };
                        return this.fieldData['employee_id'];

                    }else if (field_type == 'explanation') {
                        // this.available_objects.push(field_type);
                        this.fieldData['explanation'] = {
                            select: false,
                            type: "textarea",
                            id: "explanation",
                            label: "",
                            placeholder: "Your explanation goes here...",
                            error: false,
                            errorMessage:
                                "Please enter a valid response",
                            constraints: validators.name,
                        };
                        return this.fieldData['explanation'];

                    }else if (field_type == 'email') {
                        // this.available_objects.push(field_type);
                        this.fieldData['email'] = {
                            select: false,
                            type: "email",
                            id: "email",
                            label: "Email",
                            placeholder: "abc@abc.com",
                            error: false,
                            errorMessage:
                                "Please enter a valid Email",
                            constraints: validators.email,
                        };
                        return this.fieldData['email'];
                    }  else if (field_type == 'street') {
                        // this.available_objects.push(field_type);
                        this.fieldData['street'] = {
                            select: false,
                            type: "street",
                            id: "street",
                            label: "Street",
                            placeholder: "123 Elm St.",
                            error: false,
                            errorMessage:
                                "Please enter a valid Street",
                            constraints: validators.street,
                        };
                        return this.fieldData['street'];
                    }  else if (field_type == 'zip') {
                        // this.available_objects.push(field_type);
                        this.fieldData['zip'] = {
                            select: false,
                            type: "number",
                            id: "zip",
                            label: "Zip Code",
                            placeholder: "12345",
                            error: false,
                            errorMessage:
                                "Please enter a valid Zip Code",
                            constraints: validators.zip,
                        };
                        return this.fieldData['zip'];
                    } else if (field_type == 'username') {
                        // this.available_objects.push(field_type);
                        this.fieldData['username'] = {
                            select: false,
                            type: "username",
                            id: "username",
                            label: "Username",
                            placeholder: "username",
                            error: false,
                            errorMessage:
                                "Please enter a valid Username",
                            constraints: validators.username,
                        };
                        return this.fieldData['username'];
                    } else if (field_type == 'createUsername') {
                        // this.available_objects.push(field_type);
                        this.fieldData['createUsername'] = {
                            select: false,
                            type: "username",
                            id: "createUsername",
                            label: "Create Username",
                            placeholder: "username",
                            error: false,
                            errorMessage:
                                "Please enter a valid Username",
                            constraints: validators.createUsername,
                        };
                        return this.fieldData['createUsername'];
                    } else if (field_type == 'password') {
                        // this.available_objects.push(field_type);
                        this.fieldData['password'] = {
                            select: false,
                            type: "password",
                            id: "password",
                            label: "Password",
                            placeholder: "password",
                            error: false,
                            errorMessage:
                                "Please enter a valid password",
                            constraints: validators.password,
                        };
                        return this.fieldData['password'];
                    } else if (field_type == 'confirmPassword') {
                        // this.available_objects.push(field_type);
                        this.fieldData['confirmPassword'] = {
                            select: false,
                            type: "password",
                            id: "confirmPassword",
                            label: "Confirm Password",
                            placeholder: "confirm password",
                            error: false,
                            errorMessage:
                                "Please enter a valid password",
                            constraints: validators.password,
                        };
                        return this.fieldData['confirmPassword'];
                    }else if (field_type == 'state') {
                        // this.available_objects.push(field_type);
                        this.fieldData['state'] = {
                            select: true,
                            type: "",
                            id: "",
                            label: "State",
                            error: false,
                            errorMessage:
                                "Please enter a valid State",
                            constraints: validators.state,
                            options:
                                [
                                    {
                                        "display": "Alabama",
                                        "value": "AL"
                                    },
                                    {
                                        "display": "Alaska",
                                        "value": "AK"
                                    },
                                    {
                                        "display": "American Samoa",
                                        "value": "AS"
                                    },
                                    {
                                        "display": "Arizona",
                                        "value": "AZ"
                                    },
                                    {
                                        "display": "Arkansas",
                                        "value": "AR"
                                    },
                                    {
                                        "display": "California",
                                        "value": "CA"
                                    },
                                    {
                                        "display": "Colorado",
                                        "value": "CO"
                                    },
                                    {
                                        "display": "Connecticut",
                                        "value": "CT"
                                    },
                                    {
                                        "display": "Delaware",
                                        "value": "DE"
                                    },
                                    {
                                        "display": "District Of Columbia",
                                        "value": "DC"
                                    },
                                    {
                                        "display": "Federated States Of Micronesia",
                                        "value": "FM"
                                    },
                                    {
                                        "display": "Florida",
                                        "value": "FL"
                                    },
                                    {
                                        "display": "Georgia",
                                        "value": "GA"
                                    },
                                    {
                                        "display": "Guam",
                                        "value": "GU"
                                    },
                                    {
                                        "display": "Hawaii",
                                        "value": "HI"
                                    },
                                    {
                                        "display": "Idaho",
                                        "value": "ID"
                                    },
                                    {
                                        "display": "Illinois",
                                        "value": "IL"
                                    },
                                    {
                                        "display": "Indiana",
                                        "value": "IN"
                                    },
                                    {
                                        "display": "Iowa",
                                        "value": "IA"
                                    },
                                    {
                                        "display": "Kansas",
                                        "value": "KS"
                                    },
                                    {
                                        "display": "Kentucky",
                                        "value": "KY"
                                    },
                                    {
                                        "display": "Louisiana",
                                        "value": "LA"
                                    },
                                    {
                                        "display": "Maine",
                                        "value": "ME"
                                    },
                                    {
                                        "display": "Marshall Islands",
                                        "value": "MH"
                                    },
                                    {
                                        "display": "Maryland",
                                        "value": "MD"
                                    },
                                    {
                                        "display": "Massachusetts",
                                        "value": "MA"
                                    },
                                    {
                                        "display": "Michigan",
                                        "value": "MI"
                                    },
                                    {
                                        "display": "Minnesota",
                                        "value": "MN"
                                    },
                                    {
                                        "display": "Mississippi",
                                        "value": "MS"
                                    },
                                    {
                                        "display": "Missouri",
                                        "value": "MO"
                                    },
                                    {
                                        "display": "Montana",
                                        "value": "MT"
                                    },
                                    {
                                        "display": "Nebraska",
                                        "value": "NE"
                                    },
                                    {
                                        "display": "Nevada",
                                        "value": "NV"
                                    },
                                    {
                                        "display": "New Hampshire",
                                        "value": "NH"
                                    },
                                    {
                                        "display": "New Jersey",
                                        "value": "NJ"
                                    },
                                    {
                                        "display": "New Mexico",
                                        "value": "NM"
                                    },
                                    {
                                        "display": "New York",
                                        "value": "NY"
                                    },
                                    {
                                        "display": "North Carolina",
                                        "value": "NC"
                                    },
                                    {
                                        "display": "North Dakota",
                                        "value": "ND"
                                    },
                                    {
                                        "display": "Northern Mariana Islands",
                                        "value": "MP"
                                    },
                                    {
                                        "display": "Ohio",
                                        "value": "OH"
                                    },
                                    {
                                        "display": "Oklahoma",
                                        "value": "OK"
                                    },
                                    {
                                        "display": "Oregon",
                                        "value": "OR"
                                    },
                                    {
                                        "display": "Palau",
                                        "value": "PW"
                                    },
                                    {
                                        "display": "Pennsylvania",
                                        "value": "PA"
                                    },
                                    {
                                        "display": "Puerto Rico",
                                        "value": "PR"
                                    },
                                    {
                                        "display": "Rhode Island",
                                        "value": "RI"
                                    },
                                    {
                                        "display": "South Carolina",
                                        "value": "SC"
                                    },
                                    {
                                        "display": "South Dakota",
                                        "value": "SD"
                                    },
                                    {
                                        "display": "Tennessee",
                                        "value": "TN"
                                    },
                                    {
                                        "display": "Texas",
                                        "value": "TX"
                                    },
                                    {
                                        "display": "Utah",
                                        "value": "UT"
                                    },
                                    {
                                        "display": "Vermont",
                                        "value": "VT"
                                    },
                                    {
                                        "display": "Virgin Islands",
                                        "value": "VI"
                                    },
                                    {
                                        "display": "Virginia",
                                        "value": "VA"
                                    },
                                    {
                                        "display": "Washington",
                                        "value": "WA"
                                    },
                                    {
                                        "display": "West Virginia",
                                        "value": "WV"
                                    },
                                    {
                                        "display": "Wisconsin",
                                        "value": "WI"
                                    },
                                    {
                                        "display": "Wyoming",
                                        "value": "WY"
                                    }
                                ]
                        };
                        return this.fieldData['state'];
                    }  else if (typeof field_type_input[1] === 'object' && Object.keys(field_type_input[1])[0] == 'select') {
                        // this.available_objects.append(field_type);
                        // console.log("ITS AN OBJECT!")
                        var name = field_type_input[0]
                        // this.formOutput[name] = '';
                        this.fieldData[name] = {
                            select: true,
                            type: "select",
                            placeholder:"Select a " + name,
                            id: name,
                            label: name.charAt(0).toUpperCase() + name.slice(1),
                            error: false,
                            errorMessage:
                                "Please enter a valid " + name,
                            options: field_type_input[1]['select']
                        };
                        return this.fieldData[name];
                    } else {
                        console.log(field_type_input[1])
                    }
                }
            },
    }
</script>

<style lang="less" scoped>

    .card {
        margin:auto;
        max-width: 1000px;
        border: 2px solid black;
    }

    .checkListGood{
        color: green;
    }

    .checkListBad {
        color: darkred;
    }

    .uk-card {
        border: 1px solid grey;
    }

    .checklist {
        margin-top: 20px;
    }


</style>
